import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { ProduitComponent } from '../../../../pages/produit/produit.component';
import { Produit } from '../../model/produit';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Permission } from '../../model/permission';



@Injectable()
export class PermissionService {

  permissions: Permission[];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getPermissions() {
    this.iSconnecting = true;
    return new Promise<Permission[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_PERMISSIONS(),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Permission[]) => {
            const perms = plainToClass(Permission, data);
            this.permissions = perms;
            resolve(perms);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }



}
